import React, { useState, useEffect } from "react";
import "./request-demo.scss";
import img1 from "../../assets/images/get-in-touch/request-for-demo.png";
import PhoneInput, {
  isValidPhoneNumber,
  getCountryCallingCode,
} from "react-phone-number-input";
import { useLocation } from "react-router-dom";
import "react-phone-number-input/style.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import FormService from "../API-Services/FormService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
function RequestDemo() {
  const [numberLen, setNumberLen] = useState(25);
  const [countryCode, setCountryCode] = useState("91");
  const [mobileNum, setmobileNum] = useState("");
  const [num_error, setNum_error] = useState("");
  const [checkErrors, setCheckErrors] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [demoDateTime, setDemoDateTime] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [demoDate, setDemoDate] = useState("");
  const [demoTime, setDemoTime] = useState("");
  const [weekendError, setWeekendError] = useState(false)
  const { register,
    reset,
    handleSubmit,
    formState: { errors } } = useForm({ mode: "onChange" });
  const [loading, setLoading] = useState(false);
  //created a state variable for showing error of mobile number
  const [showError, setShowError] = useState(false);
  const location = useLocation();
  const ttl2 = location.state?.ttl2 || "Request for Demo";
  const dec=location.state?.dec || "Experience our innovation firsthand: Request a demo now!"
  const path=location.state?.path || "home"
  useEffect(() => {
  }, [ttl2]);
  function scrollErrorField() {
    //scroll up if there is any error
    if (Object.keys(errors).length > 0 && checkErrors) {
      const firstErrorField = Object.keys(errors)[0];
      // Get the corresponding input element
      const errorFieldElement = document.querySelector(
        `[name=${firstErrorField}]`
      );
      // Scroll to the error field if it exists
      if (errorFieldElement) {
        errorFieldElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }
  useEffect(() => {
    if (showToaster) {
      const timer = setTimeout(() => {
        setShowToaster(false);
      }, 10000); // Hide toaster after 10 seconds

      return () => clearTimeout(timer);
    }
  }, [showToaster]);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // 

  //Mobile Validation
  const mobileHandler = (e) => {
    if (e === undefined) {
      return;
    }
    const newValue = e.replace(/\s/g, ''); // Remove spaces from the entered value
    setmobileNum(newValue);
    // Perform other validation checks on the modified value
    if (newValue === undefined || newValue.length === 0) {
      setNum_error("Mobile Number is required");
      setShowError(true);
      return;
    }

    if (countryCode === "91") {
      setNumberLen(15);
    }
    else {
      setNumberLen(25);
    }

    if (!isValidPhoneNumber(newValue.toString())) {
      setNum_error("Please enter a valid number");
      setShowError(true);
      return;
    }
    else {
      setNum_error("");
      setShowError(false);
    }
  }
  //Quote Form Handler
  const formHandler = (data) => {

    const demoDateTime = `${demoDate} ${demoTime}:00`;
    let payload = {
      ...data,
      mobile_number: mobileNum.substring(mobileNum.indexOf(countryCode) + countryCode.length),
      country_code: countryCode,
      product: path.path || 'homepage',
      demo_date_n_time: demoDateTime,
      company_size: companySize
    }
    if (mobileNum.length <= 3) {
      setShowError(true);
      setNum_error("Mobile Number is required");
      return;
    }
    setShowError(false);
 
    if (weekendError) {
      setWeekendError(true);
      return;
    }
    setLoading(true);
    FormService.RequestForm(payload).then((res) => {
      setLoading(false);
      setCountryCode("91");
      reset();
      setmobileNum("");
      setCompanySize("")
      setDemoDate("");
      setDemoTime("");
      setShowToaster(true)
      // toast.success(res.data.message);
    }).catch((err) => {
      setLoading(false);
      if (err && err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      }
      else {
        toast.error("Something went wrong, please try again later!");
      }
    })
  }
  useEffect(() => {
    const disableDates = (date) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    };

    const dateInput = document.querySelector('input[type="date"]');
    if (dateInput) {
      dateInput.min = new Date().toISOString().split("T")[0];
      dateInput.addEventListener("input", (e) => {
        const selectedDate = new Date(e.target.value);
        if (disableDates(selectedDate)) {
          e.target.value = "";
        } 
      });
    }
  }, []);

  useEffect(() => {
    const disableWeekends = (date) => {
      const day = date.getDay();
      return day === 0 || day === 6;
    };
  
    const handleDateChange = (e) => {
      const selectedDate = new Date(e.target.value);
      if (disableWeekends(selectedDate)) {
        setWeekendError(true);
      } else {
        setWeekendError(false);
      }
      setDemoDate(e.target.value);
    };
  
    const dateInput = document.querySelector('input[type="date"]');
    if (dateInput) {
      dateInput.addEventListener("input", handleDateChange);
    }
  
    return () => {
      if (dateInput) {
        dateInput.removeEventListener("input", handleDateChange);
      }
    };
  }, []);
  return (
    <>
       <div className={`toaster toaster-top ${showToaster ? 'toaster-active' : ''}`}>
                      <div className='close-tst' onClick={() => setShowToaster(false)}>
                        <FontAwesomeIcon icon={faClose} />
                      </div>
                      <h3 className='tst-heading'>Thank You for dropping us a Hint!</h3>
                     
                    </div>

      <section className="request-demo-form">
        <div className="container">
          <div className="form-wrap">
            <div className="left-form">
              <div className="clt-form">
                <div className="frm-head">
                  <h3 className="ttl1">{ttl2}</h3>
                  <p className="sm-para">
                    {dec}
                  </p>
                </div>
                <form onSubmit={handleSubmit(formHandler)}>
                <div className="form-wrapper">
                  <div className="form-control">
                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      className="form-field"
                      maxLength={120}
                      autoComplete="off"
                      {...register("name", {
                        required: true,
                        pattern: /^[a-zA-z]+([\s][a-zA-Z]+)*$/,
                      })}
                      onInput={(e) =>
                      (e.target.value = e.target.value.replace(
                        /[^a-zA-Z ]/gi,
                        ""
                      ))
                      }
                    />
                    {errors.name?.type === "required" ? (
                      <span className="text-danger">Name is required </span>
                    ) : errors.name?.type == "pattern" ? (
                      <span className="text-danger">
                        Please provide valid name
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-control">
                    <input
                      type="text"
                      name="email"
                      autoComplete="off"
                      placeholder="Email Address"
                      className="form-field"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^[a-zA-Z]{1}[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/,
                      })}
                    />
                    {errors.email?.type === "pattern" ? (
                      <span className="text-danger">
                        Please enter valid email ID{" "}
                      </span>
                    ) : errors.email?.type === "required" ? (
                      <span className="text-danger">Email is required</span>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-control">
                    <div
                      className=""
                      onValuesChange={(val, all) => console.log(val, all)}
                    >
                      <div name="phone" label="aa">
                        <PhoneInput
                          placeholder="Enter phone number"
                          value={mobileNum}
                          name="phone_number"
                          autoComplete="off"
                          onChange={(e) => {
                            mobileHandler(e);
                          }}
                          onCountryChange={(v) =>
                            setCountryCode(getCountryCallingCode(v))
                          }
                          maxLength={numberLen}
                          defaultCountry="IN"
                          international
                          countryCallingCodeEditable={false}
                        />
                      </div>
                    </div>
                    {showError && (
                      <span className="text-danger">{num_error}</span>
                    )}
                  </div>
                  <div className="form-control">
                    <input
                      type="text"
                      name="Job_Title"
                      placeholder='Job Title' className='form-field'
                      maxLength={120}
                      autoComplete='off'
                      {...register("job_title", {
                        required: false,
                        pattern: /^[a-zA-z]+([\s][a-zA-Z]+)*$/
                      })}

                      onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z ]/gi, "")}
                    />

                  </div>
                  <div className="form-control">
                    <input
                      type="text"
                      name="company_name"
                      placeholder="Company Name"
                      className="form-field"
                      maxLength={120}
                      autoComplete="off"
                      {...register("company_name", {
                        required: false,
                        pattern: /^[a-zA-z]+([\s][a-zA-Z]+)*$/,
                      })}
                      onInput={(e) =>
                      (e.target.value = e.target.value.replace(
                        /[^a-zA-Z ]/gi,
                        ""
                      ))
                      }
                    />
                    {errors.company_name?.type === "required" ? (
                      <span className="text-danger">
                        Company Name is required{" "}
                      </span>
                    ) : errors.company_name?.type == "pattern" ? (
                      <span className="text-danger">
                        Please provide valid Company Name
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-control">
                    <select
                      className='form-field'
                      value={companySize}
                      onChange={(e) => setCompanySize(e.target.value)}
                    >
                      <option value="" disabled hidden>Company size</option>
                      <option value="1-50">1-50</option>
                      <option value="51-200">51-200</option>
                      <option value="201-500">201-500</option>
                      <option value="501+">501+</option>
                    </select>
                  </div>
                  <div className="form-control for-date-time">
                    <div className="slot-label">
                      <span>Preferred Slot</span>
                    </div>
                    <div className="form-control sub-form-control">
                    <input
                      type="date"
                      name="demo_date"
                      placeholder='Demo Date'
                      className='form-field'
                      value={demoDate} 
                      onChange={(e) => setDemoDate(e.target.value)} 
                     
                    />
                    {weekendError && (
                        <span className="text-danger">Kindly select a weekday (Monday to Friday).</span>
                      )}
                  </div>
                  <div className="form-control sub-form-control">
                     <select
                      className='form-field'
                      value={demoTime}
                      onChange={(e) => setDemoTime(e.target.value)}
                    >
                      <option value="" disabled hidden>Select Time</option>
                      <option value="11:00">11:00 AM IST</option>
                      <option value="11:30">11:30 AM IST</option>
                      <option value="12:00">12:00 PM IST</option>
                      <option value="12:30">12:30 PM IST</option>
                      <option value="01:00">01:00 PM IST</option>
                      <option value="01:30">01:30 PM IST</option>
                      <option value="02:00">02:00 PM IST</option>
                      <option value="02:30">02:30 PM IST</option>
                      <option value="03:00">03:00 PM IST</option>
                      <option value="03:30">03:30 PM IST</option>
                      <option value="04:00">04:00 PM IST</option>
                      <option value="04:30">04:30 PM IST</option>
                      <option value="05:00">05:00 PM IST</option>
                      <option value="05:30">05:30 PM IST</option>
                      <option value="06:00">06:00 PM IST</option>
                    </select>
                    {errors.demo_time?.type === "required" ? <span className="text-danger">Demo Time is required </span> : ""}
                  </div>
                  </div>
                  <div className="form-control">
                    <textarea
                      className="form-field"
                      placeholder="Comments"
                      name="comments"
                      autoComplete="off"
                      {...register("message")}
                    />
                  </div>
                  <div className="form-control">
                    <button
                      type="submit"
                      className="btn submt-btn"
                      onClick={() => {
                        setCheckErrors(true);
                        scrollErrorField();
                        if (mobileNum.length <= 3) {
                          setNum_error("Mobile Number is required");
                          setShowError(true);
                        }
                      }}
                    >
                      {loading ? (
                        <div className="loaderB mx-auto"></div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="right-form">
              <div className="img-sec">
                <img src={img1} alt={"Get a Quote"} height={837} width={558} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RequestDemo;
